module.exports = __webpack_public_path__ + "static/media/Barmag 4a3.6948080f.jpg";